import { pathMaker } from "../../../utilities/helperFunctions";
import colorSchema from "../../../assets/kits/colors/colors.module.scss";
import "./Lines.scss";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import whitebg from "../../../assets/images/defaultCover/defaultCoverProduct.png";
import useWindowSize from "../../../hooks/useWindowSize";

export default function Lines({ linesList, shopId }) {
  return (
    <div className="linesListShop">
      {linesList.length > 0 ? (
        <div className="mr-b-8 title-h4-b mr-x-20">دسته‌بندی‌ها</div>
      ) : (
        <></>
      )}
      <div className="d-flex flex-wrap mr-x-16">
        {linesList.map((item) => {
          return (
            <div className="col-4">
              <Line
                path={pathMaker(item.path)}
                name={item.title}
                shopId={shopId}
                lineId={item.suppliers_line_id}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

const Line = ({ path, name, shopId, lineId }) => {
  const [loadImg, setLoadImg] = useState(true);
  const { width } = useWindowSize();
  return (
    <div
      className={`lineShop mr-b-8 text-center ${
        width > 400 ? "mr-x-auto" : " mr-x-4"
      }  h-100 `}
    >
      <NavLink
        to={`/category/${shopId}/${lineId}`}
        className="text-decoration-none h-100  "
      >
        <div className="d-flex flex-column h-100">
          {path != null ? (
            <>
              {loadImg && (
                <img src={whitebg} style={{ height: 103, borderRadius: 6 }} />
              )}
              <img
                src={path}
                className={`${loadImg ? "d-none" : "d-block"}`}
                style={{ height: 103, borderRadius: 6 }}
                onLoad={() => setLoadImg(false)}
              />
            </>
          ) : (
            // <img
            //   src={loadImg ? whitebg : path}
            //   style={{ height: 103, borderRadius: 6 }}
            //   onLoad={() => setLoadImg(false)}
            // />
            <img src={whitebg} style={{ height: 103, borderRadius: 6 }} />
          )}
          <div
            className="desc-m w-100  mr-b-8 mr-t-auto"
            style={{ color: colorSchema.foreground_background_me, bottom: 0 }}
          >
            {name}
          </div>
        </div>
      </NavLink>
    </div>
  );
};
export { Line };
